/* global axios */
import ApiClient from './ApiClient';

class HistoryCoursesAPI extends ApiClient {
  constructor() {
    super('history_courses', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { history_course: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { history_course: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new HistoryCoursesAPI();
